import dayjs from 'dayjs';
import { SchoolYearWithoutHolidayType } from '../../components/SchoolYear/graphql/types';

export const getTeachingBlockAvailabilityRange = (schoolYear: SchoolYearWithoutHolidayType) => {
  const schoolYearStart = dayjs(schoolYear.start).startOf('day');

  return {
    from: schoolYearStart.month(7).startOf('month').toDate(),
    to: schoolYearStart.add(1, 'year').month(7).endOf('month').startOf('day').toDate(),
  };
};
